import React from 'react';
import PriceBlock from '@hpstellar/core/PriceBlock';
import PunchOut from '@hpstellar/core/PunchOut';

import { Helpers } from '../../../core/src/helpers';
import { withError } from '../../../shared/components/error-boundary';
import useProductPrice from '../../../hooks/useProductPrice';

const productPrice = ({
    product,
    /** Own price to be used if provided */
    price,
    /** Price object added to product price */
    addOnPrice,
    displayDifference = true,
    withCTOConfigurations,
    ...otherProps
}) => {
    const { prices } = useProductPrice(product ? [product] : null, { withCTOConfigurations });
    const priceObj = price || prices[product && product.sku];
    if (!priceObj) {
        return null;
    }
    let { regularPrice, salePrice } = priceObj;
    const regularPriceLabel = Helpers.formatCurrency(regularPrice, undefined, true);
    const salePriceLabel = Helpers.formatCurrency(salePrice, undefined, true);
    let productType = product.prdClass || product.product_type;
    const priceAriaLabel =
        `Sale price starting at ${salePriceLabel}.` +
        (priceObj.regularPrice > priceObj.salePrice ? ` Regular price starting at ${regularPriceLabel}` : '');

    //total price should override all mainly because of bundling
    if (addOnPrice) {
        addOnPrice.regularPrice && (regularPrice += addOnPrice.regularPrice);
        addOnPrice.salePrice && (salePrice += addOnPrice.salePrice);
    }
    return (
        <>
            <PriceBlock
                hasActiveDeal={priceObj.deal}
                regularPrice={regularPrice}
                salePrice={salePrice}
                showInCartText={priceObj.inCartPrice}
                tierMsg={priceObj.tierMsg}
                aria-label={priceAriaLabel}
                productType={['CTO', 'VGC', 'PGC'].includes(productType) ? 'cto' : productType}
                priceDifference={displayDifference ? Math.max(regularPrice - salePrice, 0) : null}
                {...otherProps}
            />
            {priceObj.isccf && (
                <PunchOut
                    availableInStock={priceObj.stock.toString()}
                    grossMargin={Helpers.formatCurrency(priceObj.gmPoints)}
                />
            )}
        </>
    );
};

export default withError(productPrice);
